import { useEffect, useState } from "react";
import axios from "axios";
import { organization, branding } from "../../config";

export default function StaffPublic() {
    const [staff, setStaff] = useState([]);
    const [logo, setLogo] = useState({ image: "", text: "" });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.title = `Staff & Board - ${organization.name}`;
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [staffRes, logoRes] = await Promise.all([
                    axios.get("/api/public/staff"),
                    axios.get("/api/public/logo"),
                ]);

                setStaff(staffRes.data.content || []);
                setLogo(logoRes.data.content || { image: "", text: "" });
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return (
            <div className="container my-5 text-center">
                <p>Loading...</p>
            </div>
        );
    }

    const boardMembers = staff.filter((member) =>
        member.role?.includes("Board Member")
    );

    const staffMembers = staff.filter(
        (member) => !member.role?.includes("Board Member")
    );

    return (
        <section
            className="container my-5"
            style={{
                fontFamily: "'Montserrat', sans-serif",
            }}
        >
            <PeopleSection
                title="Staff"
                members={staffMembers}
                logo={logo}
                startIndex={0}
            />

            <PeopleSection
                title="Board of Directors"
                members={boardMembers}
                logo={logo}
                startIndex={staffMembers.length}
            />
        </section>
    );
}

function PeopleSection({ title, members, logo, startIndex = 0 }) {
    if (!members.length) return null;

    return (
        <>
            <h2
                style={{
                    color: "var(--primary-color)",
                    fontWeight: "700",
                    marginBottom: "25px",
                    marginTop: "20px",
                    textAlign: "center",
                }}
            >
                {title}
            </h2>

            <div className="row g-4 mb-5">
                {members.map((member, index) => {
                    const imageIndex = startIndex + index;

                    return (
                        <div key={`${title}-${index}`} className="col-12 col-md-6 col-lg-4">
                            <div
                                className="card h-100 text-center"
                                style={{
                                    border: "none",
                                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                                    borderRadius: "12px",
                                    overflow: "hidden",
                                }}
                            >
                                <img
                                    src={member.image || logo.image || ""}
                                    alt={member.name}
                                    className="card-img-top"
                                    loading={imageIndex < 3 ? "eager" : "lazy"}
                                    style={{
                                        height: "300px",
                                        objectFit: member.image ? "cover" : "contain",
                                        objectPosition: "center",
                                        padding: member.image ? "0" : "20px",
                                        backgroundColor: member.image
                                            ? "transparent"
                                            : "#f8f9fa",
                                    }}
                                />

                                <div className="card-body" style={{ padding: "25px" }}>
                                    <h5
                                        className="card-title"
                                        style={{
                                            fontWeight: "700",
                                            marginBottom: "10px",
                                            fontSize: "1.25rem",
                                        }}
                                    >
                                        {member.name}
                                    </h5>

                                    <p
                                        className="card-text"
                                        style={{
                                            color: branding.primaryColor,
                                            fontSize: "0.95rem",
                                            fontWeight: "500",
                                            marginBottom:
                                                member.email || member.phone ? "15px" : "0",
                                        }}
                                    >
                                        {member.role}
                                    </p>

                                    {(member.email || member.phone) && (
                                        <div
                                            style={{
                                                fontSize: "0.9rem",
                                                color: "#555",
                                                textAlign: "center",
                                            }}
                                        >
                                            {member.email && (
                                                <div style={{ marginBottom: "5px" }}>
                                                    <a
                                                        href={`mailto:${member.email}`}
                                                        style={{
                                                            color: branding.primaryColor,
                                                            textDecoration: "none",
                                                            wordBreak: "break-word",
                                                        }}
                                                    >
                                                        {member.email}
                                                    </a>
                                                </div>
                                            )}

                                            {member.phone && (
                                                <div>
                                                    <a
                                                        href={`tel:${member.phone.replace(/\D/g, "")}`}
                                                        style={{
                                                            color: branding.primaryColor,
                                                            textDecoration: "none",
                                                        }}
                                                    >
                                                        {member.phone}
                                                    </a>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}